<div class="spinner-container">
  <mat-progress-spinner
    class="spinner"
    [diameter]="20"
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>
